<template>
  <el-button
    class="y-button"
    v-bind="$attrs"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot />
  </el-button>
</template>

<script setup>
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["click"]);

const handleClick = () => {
  if (props.disabled) {
    return;
  }
  emit("click");
};

defineOptions({
  name: "YButton"
});
</script>

<style lang="scss" scoped>
.y-button {
  --el-border-radius-base: 0;
  --y-button-space: 20px;
  --y-button-border-color: var(--y-brand-btn-color);
  border: 1px solid var(--y-button-border-color);
  width: var(--y-button-width);
  height: var(--y-button-height);
  font-family: var(--y-button-font, var(--y-medium-font));
  font-weight: var(--y-button-weight);
  font-size: var(--y-button-size);
  &.is-plain {
    --y-button-border-color: var(--y-border-color);
    --el-button-bg-color: transparent;
    --el-button-hover-bg-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
  + .y-button {
    margin-left: var(--y-button-space);
  }
}
</style>
